import { graphql } from "react-relay";

export const RemoveNotificationRuleMutation = graphql`
  mutation RemoveNotificationRuleMutation(
    $input: RemoveNotificationRuleInput!
  ) {
    removeNotificationRule(input: $input) {
      removed {
        id @deleteRecord
      }
      problems {
        message
      }
    }
  }
`;
